/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const sendSmsRequestSchema = z
	.object({
		country_code: z.string().max(4).optional().default("+7"),
		phone: z.string().max(20),
		group_external_id: z.uuid(),
		message: z.string(),
	})
	.describe("Сериализатор запроса на отправку SMS.");
